const fixAlt = (el) => {
    if (!el.hasAttribute('alt')) el.setAttribute('alt', '');
};

document.querySelectorAll('img').forEach(fixAlt);

new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            if (node.nodeType !== Node.ELEMENT_NODE) return;
            if (node.tagName === 'IMG') fixAlt(node);
            node.querySelectorAll('img').forEach(fixAlt);
        });
    });
}).observe(document.body, { childList: true, subtree: true });
